import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { NovedadI } from 'src/app/modelos/Novedad';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { VistaHistoricoNovedadesI } from 'src/app/modelos/VistaHistoricoNovedades';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AdmininformacionService } from 'src/app/servicios/admininfo/admininformacion.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';


@Component({
  selector: 'app-crearnovedad',
  templateUrl: './crearnovedad.component.html',
  styleUrls: ['./crearnovedad.component.css']
})
export class CrearnovedadComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteI = new PeriodoReporteI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  PeriodosConsultar : PeriodoReporteI[];
  IdPeriodoConsulta : BigInteger;
  ListaEstadosFuentes : VistaAdminInfoI[];
  NovedadNueva : NovedadI = new NovedadI;
  EstadoInformacionSelect : EstadoInfoChvI = new EstadoInfoChvI;
  EstadoInformacionSelectVer : EstadoInfoChvI = new EstadoInfoChvI;
  Fuente : fuenteI = new fuenteI;
  PeriodoNovedad : PeriodoReporteI = new PeriodoReporteI;
  PeriodoModalNovedad : String;
  PeriodoModalVer : String;
  TipoNovNueva : String = "";
  ObserNovNueva : String = "";
  BtnCrearNov : Boolean = false;
  HistricoNovedadFuente : VistaHistoricoNovedadesI[];
  page : number;

  @ViewChild('openmodalconfirmar') openmodalconfirmar: ElementRef;
  @ViewChild('closemodalconfirmar') closemodalconfirmar: ElementRef;
  @ViewChild('openmodalcrearnovedad') openmodalcrearnovedad: ElementRef;
  @ViewChild('closemodalcrearnovedad') closemodalcrearnovedad: ElementRef;
  @ViewChild('openmodalvernovedad') openmodalvernovedad: ElementRef;
  @ViewChild('closemodalvernovedad') closemodalvernovedad: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService,
    private admininfo:AdmininformacionService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.analisisService.consultarPeriodoActivoCHV().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
      this.IdPeriodoConsulta = PActivo.id;
    });
    this.admininfo.TodosEstadosPeriodoActivoAdminInfoChv().subscribe(result1=>{
      this.ListaEstadosFuentes = result1;
      this.dtTrigger.next();
    });
    this.analisisService.getListaAniosVigenciaChv().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminChv(){
    this.router.navigate(['admininfochv']);
  }

  CosultarListaEstados(){
    if(this.consucutivoConsulta==0 || this.anioConsulta == 0){
      console.log("Seleccione periodo completo");
    } else {
      this.api.PeriodoPorConsecutivoAnio(this.consucutivoConsulta, this.anioConsulta).subscribe(resultado1=>{
        this.PeriodoSeleccionado = resultado1;
        this.IdPeriodoConsulta = resultado1.id;
        this.api.EstadosInfoParaPeriodoChv(resultado1.id).subscribe(Lista2=>{
          this.ListaEstadosFuentes = Lista2;
          this.reinicializarDataTable();
        });
      });
    }
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  /*CosultarListaEstados(IdPeriodo){
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.PeriodoPorId(IdPeriodo).subscribe(Result2_2=>{
      this.PeriodoNovedad = Result2_2;
    });
    this.api.EstadosInfoParaPeriodoChv(IdPeriodo).subscribe(result2=>{
      this.ListaEstadosFuentes = result2;
    });
  }*/

  ConfirmarCrearNovedad(idEstadoInformacion){
    this.openmodalconfirmar.nativeElement.click();
    this.api.ConsultarEstadoInfoPorId(idEstadoInformacion).subscribe(Result3=>{
      this.EstadoInformacionSelect = Result3;
      this.PeriodoModalNovedad = Result3.anio+" - "+Result3.periodo;
      this.api.getFuenteById(Result3.fuente.id).subscribe(Result4=>{
        this.Fuente = Result4;
      });
    });
  }

  AsignarNovedad(){
    this.TipoNovNueva = "";
    this.ObserNovNueva = "";
    this.closemodalconfirmar.nativeElement.click();
    this.openmodalcrearnovedad.nativeElement.click();
  }

  GuardarNovedad(){
    this.BtnCrearNov = true;
    let date = new Date();
    this.EstadoInformacionSelect.estado = "Cargado";
    this.EstadoInformacionSelect.novedadSis = "99 - Rinde / Novedad reportada"
    this.EstadoInformacionSelect.novedadUsu = this.TipoNovNueva;
    this.EstadoInformacionSelect.observacionFte = this.ObserNovNueva;
    this.NovedadNueva.idFte = this.Fuente.id;
    this.NovedadNueva.idUsuario = localStorage.getItem('id');
    this.NovedadNueva.idPerido = this.EstadoInformacionSelect.idperiodo.id;
    this.NovedadNueva.fechaNov = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
    this.NovedadNueva.tipoNov = this.TipoNovNueva;
    this.NovedadNueva.justNov = this.ObserNovNueva;
    if(this.TipoNovNueva == ""){
      this.toastr.warning('Debe seleccionar el tipo de novedad.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva == ""){
      this.toastr.warning('Observación corta.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva.length < 20){
      this.toastr.warning('Observación muy corta.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva.length > 255){
      this.toastr.warning('Observación debe tener máximo 255 caracteres.','Advertencia!');
      this.BtnCrearNov = false;
    } else {
      this.api.GuardarEstadoInformacionChv(this.EstadoInformacionSelect).subscribe(Result5=>{
        if(Result5){
          this.api.nuevoNovedadFuente(this.NovedadNueva).subscribe(Result6=>{
            if(Result6){
              this.toastr.success('Novedad asignada.','OK!');
              this.closemodalcrearnovedad.nativeElement.click();
              this.CosultarListaEstados();
            }
          },error=>{
            this.BtnCrearNov = false;
            this.toastr.error('Error al guardar novedad.','error!');
          });
        }
      }, error=> {
        this.BtnCrearNov = false;
        this.toastr.error('Error al guardar novedad.','error!');
      });
    }
  }

  VerNovedad(idEstadoInformacion){
    this.api.ConsultarEstadoInfoPorId(idEstadoInformacion).subscribe(Result7=>{
      this.EstadoInformacionSelectVer = Result7;
      this.PeriodoModalVer = Result7.anio+" - "+Result7.periodo;
      this.api.getFuenteById(Result7.fuente.id).subscribe(Result8=>{
        this.Fuente = Result8;
      });
      this.api.ConsultarNovedadesFuentePeriodo(Result7.fuente.id, this.IdPeriodoConsulta).subscribe(Result9=>{
        this.HistricoNovedadFuente = Result9;
        this.openmodalvernovedad.nativeElement.click();
      });
    });
  }










}
